<!-- eslint-disable vue/no-v-html -->
<template>
	<div
		v-if="text.length"
		class="disclaimer-text"
		v-html="text"
	/>
</template>


<style lang="scss">
.disclaimer-text {
	margin-top: 24px;
	margin-bottom: 24px;
}
</style>


<script setup>
const props = defineProps({
	text: {
		type: String,
		default: '',
	},
})
</script>
